import Vue from 'vue'
import Vuex from 'vuex'
import UserInfo from './modules/UserInfo.js'
import ScoreTable from './modules/ScoreTable.js'
import TheScoreSlider from './modules/TheScoreSlider.js'
import firebase from 'firebase'
// import 'Firebase/firestore'

Vue.use(Vuex)

let config = {
  apiKey: 'AIzaSyA0xmRYsdAzrbark3lZQZ8cj0gUp58WeF4',
  authDomain: 'mahjong-tensu.firebaseapp.com',
  databaseURL: 'https://mahjong-tensu.firebaseio.com',
  projectId: 'mahjong-tensu',
  storageBucket: 'mahjong-tensu.appspot.com',
  messagingSenderId: '336285987279'
}
const firebaseApp = firebase.initializeApp(config)
const firestore = firebaseApp.firestore()

firestore.settings({ timestampsInSnapshots: true })
const state = {
  db: firebase.firestore()
}

export default new Vuex.Store({
  state,
  modules: {
    ScoreTable,
    TheScoreSlider,
    UserInfo
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js